const ns = "EVENTS";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;
export const TOGGLE_STARRED_EVENT = `${ns}_TOGGLE_STARRED_EVENT`;
